namespace $.$$ {
	$mol_style_define( $shm_hitalama_components_preview_description, {
		flexDirection: 'column',
		minWidth: 0,
		Header: { alignItems: 'center', flexWrap: 'wrap' },
		Label: { color: $mol_theme.shade, padding: $mol_gap.text },
		Text: {
			'>': { $mol_paragraph: { ':first-child': { padding: { top: 0 } } } },
		},
		Textarea: { minWidth: 0, maxWidth: '100%' },
		Save: { alignSelf: 'flex-start' },
	})
}
